// Format validators for Stripe billing form fields (name, city, state, address)
// Rejects numeric/garbage input while allowing accented international characters

const NAME_ALLOWED_CHARS = /^[A-Za-zÀ-ɏḀ-ỿ\s'.\-]+$/;
const HAS_LETTER = /[A-Za-zÀ-ɏḀ-ỿ]/;

export const isValidPersonName = (value: string): boolean => {
  const trimmed = value.trim();
  if (trimmed.length < 2) return false;
  if (!NAME_ALLOWED_CHARS.test(trimmed)) return false;
  return HAS_LETTER.test(trimmed);
};

export const isValidPlaceName = (value: string): boolean => isValidPersonName(value);

export const isValidAddressLine = (value: string): boolean => {
  const trimmed = value.trim();
  if (trimmed.length < 3) return false;
  return HAS_LETTER.test(trimmed);
};
